import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Home } from '../Home';
import { ConsumerContract } from './model/consumer-contract.model';
import { Contract } from './model/contract.model';
import { ConsumerContractService } from './service/consumer-contract.service';

@Component({
  selector: 'app-consumer-contract',
  templateUrl: './consumer-contract.component.html',
  styleUrls: ['./consumer-contract.component.css']
})
export class ConsumerContractComponent extends Home implements OnInit {

  lastupdated: any;
  classifications: any;
  age: any;
  rmodal: boolean;
  btn: boolean;
  types: any;

  constructor(private router: Router, private activated: ActivatedRoute, public model: Contract,
    public consumer: ConsumerContract, private consumerContractService: ConsumerContractService) {
    super(router);
    this.rmodal = false;
  }

  ngOnInit(): void {
    this.consumer = new ConsumerContract();
    if (this.activated.snapshot.params.id) {
      this.load(this.activated.snapshot.params.id);
    }

    this.loadTypes();
    this.loadClassification();
  }

  loadTypes() {
    this.types = [{ id: 'C', name: 'Contrato' }, { id: 'A', name: 'Aditivo' }];
  }

  load(id) {
    const socket = this.consumerContractService.getId(id + '/consumer')
      .subscribe(succ => {
        const ret: any = succ;
        this.consumer.load(ret);
        this.lastupdated = ret.updated;
        this.birthToage();
      }, err => {
        this.allowAcess(err.status);
        this.popup(this.consumerContractService.msg[err.error.code], 'danger');
        console.log('err', err);
      }, () => {
        socket.unsubscribe();
      });
  }

  birthToage() {
    this.age = this.consumer.age();
  }

  myprofile(id) {
    if (!id) { return; }
    this.go('./home/consumer', id);
  }

  myrequest(id) {
    if (!id) { return; }
    this.go('./home/consumer-request', id);
  }

  visiblemodal() {
    this.rmodal = !this.rmodal;
    this.model = new Contract();
  }

  doRequest(model, valid) {

    if (!valid || this.btn) { return; }
    model.consumerid = this.consumer.id;
    this.btn = !this.btn;

    if (!model.id) {
      this.doInsert(model);
    } else {
      this.doUpdate(model);
    }
  }

  doInsert(model) {
    const socket = this.consumerContractService.post(model)
      .subscribe(succ => {
        const ret: any = succ;
        this.popup('Contrato incluído com sucesso!');
        this.visiblemodal();
        this.consumer.contracts = undefined;
        this.load(this.consumer.id);
        this.btn = !this.btn;
      }, err => {
        this.allowAcess(err.status);
        this.popup(this.consumerContractService.msg[err.error.code], 'danger');
        console.log('err', err);
        this.btn = !this.btn;
      }, () => {
        socket.unsubscribe();
      });
  }

  doUpdate(model) {
    const socket = this.consumerContractService.patch(model.id, model)
      .subscribe(succ => {
        const ret: any = succ;
        this.popup('Contrato atualizada com sucesso!');
        this.visiblemodal();
        this.consumer.contracts = undefined;
        this.load(this.consumer.id);
        this.btn = !this.btn;
      }, err => {
        this.allowAcess(err.status);
        this.popup(this.consumerContractService.msg[err.error.code], 'danger');
        console.log('err', err);
        this.btn = !this.btn;
      }, () => {
        socket.unsubscribe();
      });
  }

  loadClassification() {
    const socket = this.consumerContractService.dropdown('classification/Contrato')
      .subscribe(succ => {
        const ret: any = succ;
        this.classifications = ret;
      }, err => {
        console.log('err', err);
        this.allowAcess(err.status);
      }, () => {
        socket.unsubscribe();
      });
  }

  open(model) {
    this.visiblemodal();
    this.model.load(model);
  }
}
